export default {
  memberReferral: 'Friend Referral',
  'memberReferral.title': 'Earn Rewards with Friends',
  'memberReferral.description':
    'Ask your friend to enter your referral code during sign-up,<br />or register via the referral link directly.',
  'memberReferral.code': 'Referral Code',
  'memberReferral.url': 'Referral Link',
  'memberReferral.copy.success': 'Copied successfully!',
  'memberReferral.message.disabled': 'The campaign is not currently active!',
  'memberReferral.message.title': 'Join {name} with Me!',
  'memberReferral.message.description':
    'Friend Referral Code: {code}. Enter the code during sign-up, or click the referral link to register directly.',
  'memberReferral.message.join': 'Join Now',
  'memberReferral.message.share': 'Share',
  'memberReferral.message.success': 'Referral link shared successfully!',
  'memberReferral.message.version': 'Your LINE version is outdated. Please update and try again.',
  'memberReferral.message.fail': 'Sharing failed. Please try again later.',
} as Record<string, string>;
